export default __webpack_public_path__ + "static/media/image-photography.26df83b3.jpg";